import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  List,
  ListItemButton,
  Divider,
} from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AddIcon from '@mui/icons-material/Add';
import { Link, useLocation } from 'react-router-dom';
import OutlinedButton from './OutlinedButton';
import ProposeTopicDialog from './ProposeTopicDialog';
import { useAuth } from './AuthContext';

export default function TopicsSidebar({
  topics = [],
  selectedTopicName,
  institutionId,
  firstTopicRef = null,
}) {
  const location = useLocation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const { user, emailVerified } = useAuth();
  const topTopics = [...(topics || [])].sort(
    (a, b) => (b.totalThreads || 0) - (a.totalThreads || 0)
  );

  const canPropose = user && emailVerified;

  return (
    <>
    <Card variant="outlined" sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, ml: 2 }}>
        <LocalOfferIcon fontSize="small" color="success" sx={{ mr: 1 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          Topics
        </Typography>
      </Box>
      <List disablePadding>
        {topTopics.map((topic, idx) => (
          <React.Fragment key={topic.id}>
            <ListItemButton
              ref={idx === 0 ? firstTopicRef : null}
              component={Link}
              to={`/community/topic/${encodeURIComponent(topic.name)}`}
              state={{ from: location.pathname }}
              selected={
                (selectedTopicName || '').toLowerCase() ===
                (topic.name || '').toLowerCase()
              }
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                py: 1,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ width: 10, height: 10, borderRadius: '2px', bgcolor: topic.color }} />
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {topic.name}
                </Typography>
              </Box>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {topic.totalThreads}
              </Typography>
            </ListItemButton>
            {idx !== topTopics.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
      {canPropose && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <OutlinedButton
            onClick={() => setDialogOpen(true)}
            startIcon={<AddIcon />}
            text="Propose Topic and Subtopic"
            color="success"
            size="small"
          />
        </Box>
      )}
    </Card>
    <ProposeTopicDialog
      open={dialogOpen}
      onClose={() => setDialogOpen(false)}
      topics={topics}
      institutionId={institutionId}
    />
    </>
  );
}
